import { PageId } from 'constants/pages'

export const enum PageIdWoofzNrday65 {
  SUBSCRIPTIONS_NRDAY_65_N = PageId.SUBSCRIPTIONS_NRDAY_65_N,
  CHAT_UPSELL_NRDAY_65 = PageId.CHAT_UPSELL_NRDAY_65,
  UPSELL_NRDAY_65 = PageId.UPSELL_NRDAY_65,
  DOWNLOAD_NRDAY_65 = PageId.DOWNLOAD_NRDAY_65,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
